import postAPI from './postAPI.js'

export default async function postSetPaymentStepAmount(body) {
    const data = await postAPI('admin/taskinstances/steps/payment/setamount', body);
    return data;
}
